import { EEGPage } from "./EEGPage";
import { TimeSeriesPageManager } from "./TimeSeriesPageManager";

// Six in-flight page requests hide enough per-request round-trip latency to sustain
// 20 pages per second in the MCP-6865 acceptance tests. Raising it increases Dask load
// and the time other reviewers wait, so treat it as a tuned value rather than a knob.
const EEG_PAGE_REQUEST_CONCURRENCY = 6

const EEG_CACHED_PAGES = 256

export class EEGTimeSeriesPageManager extends TimeSeriesPageManager<EEGPage> {
	constructor() {
		super(EEG_PAGE_REQUEST_CONCURRENCY)
	}

	getPageMaker(): () => EEGPage {
		return (): EEGPage => new EEGPage(this)
	}

	protected getNumberOfCachedPages(): number {
		return EEG_CACHED_PAGES
	}

	// During playback the reviewer only moves forward, so keep most of the cache ahead of the
	// playhead. Paused review scrubs in both directions and gets the symmetric default.
	protected getCachedPagesBehindCurrentPage(): number {
		return this.prioritizeAheadPages ? EEG_CACHED_PAGES / 4 : super.getCachedPagesBehindCurrentPage()
	}
}
